import React from "react";
import { MobileMenu } from "./MobileMenu";
import { useStickyMenu } from "../../lib/hooks/useStickyMenu";
import { LOGO } from "../../lib/assets";
import { NavMenus } from "./NavMenus";
import { LocaleLink } from "../../i18n/LocaleLink";
import { LanguageSwitcher } from "../../i18n/LanguageSwitcher";
import { useTranslation } from "react-i18next";

export const HeaderSix = () => {
  // menu sticky
  useStickyMenu();
  const { t } = useTranslation();


  return (
    <>
      <div id="header-fixed-height"></div>
      <header className="header-style-six">
        <div className="heder-top-wrap">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-7">
                <div className="header-top-left">
                  <ul className="list-wrap">
                    {/* <li>
                      <i className="flaticon-location"></i>Carrera 100 # 10-10, Bogotá, Colombia
                    </li> */}
                    <li>
                      <i className="flaticon-mail"></i>
                      <a href="mailto:info@caomei.com.co">info@caomei.com.co</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="header-top-right">
                  <div className="header-contact">
                    <a href="tel:0573044089089">
                      <i className="flaticon-phone-call"></i>+57 304 408 9089
                    </a>
                  </div>
                  <LanguageSwitcher className="header-language" />
                  <div className="header-social">
                    <ul className="list-wrap">
                      {/* <li>
                        <a href="#">
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      </li> */}
                      <li>
                        <a href="#">
                          <i className="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fab fa-instagram"></i>
                        </a>
                      </li>
                      {/* <li>
                        <a href="#">
                          <i className="fab fa-pinterest-p"></i>
                        </a>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="sticky-header" className="menu-area">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="mobile-nav-toggler">
                  <i className="fas fa-bars"></i>
                </div>
                <div className="menu-wrap">
                  <nav className="menu-nav">
                    <div className="logo">
                      <LocaleLink to="/">
                        <img src={LOGO} alt="Logo" />
                      </LocaleLink>
                    </div>

                    {/* nav links */}
                    <NavMenus />

                    <div className="header-action d-none d-md-block">
                      <ul className="list-wrap">
                        {/* <li className="header-search">
                          <a href="#">
                            <i className="flaticon-search"></i>
                          </a>
                        </li> */}
                        <li className="header-btn">
                          <LocaleLink to="/contact" className="btn btn-two">
                            {t("nav.contactCta")}
                          </LocaleLink>
                        </li>
                      </ul>
                    </div>
                  </nav>
                </div>

                {/* Mobile Menu  */}
                <MobileMenu />
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};
